module.exports = __webpack_public_path__ + "static/media/slider2_mob.58753c13.png";